import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-banner',
  templateUrl: './add-banner.component.html',
  styleUrls: ['./add-banner.component.css']
})
export class AddBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
